import { createReducer, on } from '@ngrx/store';
import { User } from '../domain/models/user';
import {
  authInitialized,
  loginButtonClicked,
  loginError,
  loginNotAuthenticated,
  loginSuccess,
  logoutButtonClicked,
  logoutSuccess,
  onInitLoginPage,
  setDeviceFingerprint,
} from './auth.actions';

export interface AuthState {
  user?: User;
  token?: string;
  loading: boolean;
  error?: string;
  initialized: boolean;
  fingerprint: string | null;
}

export const initialState: AuthState = {
  user: undefined,
  loading: false,
  error: '',
  initialized: false,
  fingerprint: null,
};

export const authReducer = createReducer(
  initialState,

  on(onInitLoginPage, (state) => ({
    ...state,
  })),

  on(loginNotAuthenticated, (state) => ({
    ...initialState,
    initialized: true,
  })),

  on(loginButtonClicked, () => ({
    ...initialState,
    loading: true,
  })),

  on(loginSuccess, (state, action) => ({
    ...state,
    user: action.user,
    token: action.token,
    loading: false,
    initialized: true,
  })),

  on(loginError, (state, action) => ({
    ...state,
    error: action.error,
    loading: false,
    initialized: true,
  })),

  on(logoutButtonClicked, (state: AuthState) => ({
    ...state,
    user: undefined,
    loading: false,
  })),

  on(logoutSuccess, (state, action) => ({
    ...initialState,
  })),

  on(authInitialized, (state) => ({
    ...state,
    initialized: true,
  })),

  on(setDeviceFingerprint, (state, { fingerprint }) => ({
    ...state,
    fingerprint,
  })),
);
